export default __webpack_public_path__ + "static/media/card2mob.c8045811.png";